export var checkEqual = function (a, b) { return JSON.stringify(a) === JSON.stringify(b); };
